import React, { useState, useEffect } from "react";
import { Switch, Route } from "react-router-dom"; 
import ProcessCard from "./processCard";
import { getProcesses } from "../../Redux/actions/processes";
import Instances from "./instances";
import Versions from "./versions";
import "./index.css";
import loader from "../../Assets/loaderTransaparent.gif";

function Flows(props) {  

    let { history ,reloadProcess} = props;
    let [botsData,setBotsData] = useState([...props.bots])
    let [currentPage, setCurrentPage] = useState('1')
    let [offSet,setOffSet] = useState('0')
    let [limit,setLimit] = useState('6')
    let [startIndex,setStartIndex]  = useState('0')
    let [endIndex,setEndIndex] = useState('10')
    let [count,setCount] = useState(props.count)
    let [previousBtnPage,setPreviousBtnPage] = useState()
    let [nextBtnPage,setNextBtnPage] = useState()  
    const [flow, setFlow] = useState({});
    const [search_data,setsearch_data] = useState()
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState({...props.location})

    useEffect(()=> {
      setLocation({...props.location});      
      if(props.location.pathname === "/processes"){
        setFlow({});
      }
    }, [props.location])

    useEffect(() => {
      if (botsData.length > 0) {
        let flowname = location.pathname.split("/")[2];
        let flow = botsData.find(obj => obj.name === flowname);        
        if(flow){
            setFlow(flow);
        }else if(flowname){
            history.push("/processes")
        }
      }
    }, [location, history, botsData]); 

    const getUpdateData = async(startlimit)=>{
      let payload={
        offSet,limit
      }
      let data = await getProcesses(payload);  
      setCount(data.count) 
      if(data.rows.length === 0){
        await reloadProcess()
        setCurrentPage((parseInt(currentPage) + 1).toString())
        let payloadobj={
          offSet:offSet-6,
          limit
        }
        let data = await getProcesses(payloadobj);                 
        setBotsData(data.rows)  
      }else{          
        setBotsData(data.rows)
      }

    }
      const handleClick=(event)=> { 
      let payload;
      if(currentPage < event.target.id){
          setOffSet(parseInt(offSet)+(6*(event.target.id-currentPage)))
          payload={
            offSet:parseInt(offSet)+(6*(event.target.id-currentPage)),limit
          }
      }else if(currentPage > event.target.id){    
          setOffSet(parseInt(offSet)-(6*(currentPage-event.target.id)))
          payload={
            offSet:parseInt(offSet)-(6*(currentPage-event.target.id)),limit
          }
      }
      else{
          setOffSet(offSet)
          payload={
            offSet,limit
          }
      }
        setLoading(true)
        const fetchData = async () => {
          let data = await getProcesses(payload); 
          setLoading(false)
          setBotsData(data.rows)
        }
        fetchData()
        setCurrentPage(event.target.id)
    }

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(count/6); i++) {      
      pageNumbers.push(i);            
    }

   const handlePrev = (event) => {  
    setPreviousBtnPage(parseInt(currentPage)-1)
    if(currentPage.endsWith('1') && currentPage!=='10'){
       setStartIndex(parseInt(startIndex)-10)
       setEndIndex(parseInt(endIndex)-10)    
    }
     setOffSet(parseInt(offSet)-6)
      let payload={
        offSet:parseInt(offSet)-6,
        limit
      } 
      setLoading(true)
      const fetchData = async () => {
        let data = await getProcesses(payload); 
        setLoading(false)
        setBotsData(data.rows)
      }
      fetchData()
      setCurrentPage((parseInt(currentPage) - 1).toString())
    }
    
    const handleNext = (event) => {
      setNextBtnPage(parseInt(currentPage)+1)
      if(currentPage.endsWith('0')){
        setStartIndex(parseInt(startIndex)+10)
        setEndIndex(parseInt(endIndex)+10)  
      } 
      setOffSet(parseInt(offSet)+6)
      let payload={
        offSet:parseInt(offSet)+6,
        limit
      }      
      setLoading(true)
      const fetchData = async () => {
        let data = await getProcesses(payload);   
        setLoading(false)   
        setBotsData(data.rows)
      }
      fetchData()
      setCurrentPage((parseInt(currentPage) + 1).toString())
    }
    
    const handleSearch = async () =>{
      if(search_data){
          let org = props.botsList.find((obj) => obj.name.toLowerCase() == search_data.toLowerCase()); 
          if(org){
               setBotsData([org]) 
          }
          else{
            setBotsData([])  
          }
      }
    }

    const keyPress = async(e) => {
      if (e.key === 'Enter' ){
        handleSearch()
      }
    }
    const fetchData = async () => {    
      setLoading(true);
      let payload={
        offSet,
        limit
      } 
      let data = await getProcesses(payload);
      setLoading(false);
      if (data.rows.length > 0) {
        setBotsData(data.rows)  
      }
    };

    const handleChange = (e) =>{    
      setsearch_data(e.target.value)
      if(e.target.value.length === 0){
        setsearch_data(null)
        fetchData()
      }
    }
      const compare = (a, b)  => {
        var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase();
        if (nameA < nameB) 
         return -1;
        if (nameA > nameB)
         return 1;
        return 0; 
       };

      const renderPageNumbers = pageNumbers.slice(startIndex, endIndex).map(number => {  
        return (
          pageNumbers.length > 1 ?<button onClick={handleClick}  id={number} style={{padding:"5px 10px",border: "solid 1px #d2c5c5",display:"flex",justifyContent:"center",color:"black" ,marginTop:"-2px"}} className={number.toString() === currentPage? "active1":""} key={number}>
            {number}
            </button>:""     
         );
      });
       if(loading){
        return (
          <div className="main-content">
            <div className="header-content">
              <label>Action Flows</label>
            </div>
            <div style={{ textAlign: "center", marginTop: "15%" }}>
              <img src={loader} width="100" alt="loading"></img>
            </div>
            <div className="pagination_button">
            {pageNumbers.length > 1 ? <button onClick={handlePrev}  className="img_but"  disabled={currentPage === '1' }>&laquo;</button>:""}
                {renderPageNumbers}
            {pageNumbers.length > 1 ?<button onClick={handleNext}  className="img_but" disabled={pageNumbers.length.toString() === currentPage && pageNumbers.length.toString()>endIndex ||pageNumbers.length.toString() === currentPage}>&raquo;</button>:""}
           </div>
          </div>
        );
      }
  
    else if(flow.name){
        return (
          <Switch>
            <Route
              path={`${props.match.path}/:flowName/instances`}
              render={() => <Instances flow={flow} />}
            />
            <Route
              path={`${props.match.path}/:flowName/versions`}
              render={() => <Versions flow={flow} getUpdateData={getUpdateData} offSet={offSet}/>}
            />
          </Switch>
        );
    }else{ 
        return (
          <div className="main-content">
            <div className="header-content">
              <label>Action Flows</label>
                    <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"240px",padding:"7px",marginTop:"7px"}}></i>
                    <input type="text"  name="search_data" onChange={handleChange} onKeyPress={keyPress} placeholder="Search" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"95px"}}/>
                    <button className="btn" onClick={() => props.toggle()}>Publish</button>
            </div>
             <div className="content">
               {botsData.sort(compare).map((obj, ind) => {
                return <ProcessCard key={ind} bot={obj} {...props}  getUpdateData={getUpdateData} offSet={offSet}/>
              })} 
            </div> 
            {search_data == null?
            <div className="pagination_button">
            {pageNumbers.length > 1 ? <button onClick={handlePrev}  className="img_but"  disabled={currentPage === '1' }>&laquo;</button>:""}
                {renderPageNumbers}
            {pageNumbers.length > 1 ?<button onClick={handleNext}  className="img_but" disabled={pageNumbers.length.toString() === currentPage && pageNumbers.length.toString()>endIndex ||pageNumbers.length.toString() === currentPage}>&raquo;</button>:""}
           </div>:""}
          </div>
        )
    }
}

export default Flows;
